// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"35e0aa00","455":"aecc2544"}[chunkId] + ".chunk.js";
};